var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensioning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 710",
    d: "M0.8125 1.33777V14.6623",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 712",
    d: "M12.9733 10.914H2.54975",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 711",
    d: "M15.1875 1.33777V14.6623",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 14",
    d: "M1.28937 10.9141L3.63978 9.346L3.63978 12.4822L1.28937 10.9141Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 15",
    d: "M14.7062 10.7097L12.3558 12.2778L12.3558 9.14157L14.7062 10.7097Z",
    fill: "#626262"
  })), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M10.5469 3.20465H8.36426V8.89899H7.38281V3.20465H5.20996V2.33551H10.5469V3.20465Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensioning);
export default __webpack_public_path__ + "static/media/dimensioning.986b412f7d2e61cb729d2bc10bcc5c58.svg";
export { ForwardRef as ReactComponent };